const CONSENT_CONTRACT_PATH: string = '/consent-contracts';

export const CONSENT_CONTRACT_PATHS = {
    LANDING_PAGE: CONSENT_CONTRACT_PATH,
    CREATE_NEW_CONSENT_CONTRACT: `${CONSENT_CONTRACT_PATH}/new`,
    UPDATE_CONSENT_CONTRACT: `${CONSENT_CONTRACT_PATH}/:chain/:sdoId`,
    CONSENT_CONTRACT_RECEIPTS: `${CONSENT_CONTRACT_PATH}/receipt/:chain/:sdoId`,
};
